import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=5511c156&scoped=true"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"
import style0 from "./Person.vue?vue&type=style&index=0&id=5511c156&prod&scoped=true&lang=css"
import style1 from "./Person.vue?vue&type=style&index=1&id=5511c156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5511c156",
  null
  
)

export default component.exports